module.exports = __webpack_public_path__ + "img/02-6流程透明.1e7db52c.svg";